import svg4everybody from "svg4everybody";
import $ from "jquery";
import Page from "webPage/Page";
import { handleContactForm } from "pages/Contact";


$(function () {
    document.documentElement.setAttribute('data-useragent', navigator.userAgent);
    if (!!window.MSInputMethodContext && !!document.documentMode) {
        $('html').addClass('ie11');
    }

    svg4everybody();
    Page.init();

    $('.nav-services a').hover(function () {
        $('.dropdown').addClass('show');
    }, function () {
        $('.dropdown').removeClass('show');
    });

    $('.nav-funding a').hover(function () {
        $('.dropdown_2').addClass('show');
    }, function () {
        $('.dropdown_2').removeClass('show');
    });

    let $form = $(".js-footer-form");
    if ($form.length > 0) {
        handleContactForm($form);
    }
});
